import { DataAccessError } from "app/common/errors/DataAccessError"
import { PrismaPromise } from "db"
import { taskEither } from "fp-ts"
import { Lazy } from "fp-ts/function"

export const dba = <A>(f: Lazy<Promise<A>>) =>
  taskEither.tryCatch(f, (reason) => DataAccessError.of(String(reason)))

export const dba2 = <A>(f: Lazy<PrismaPromise<A>>) =>
  taskEither.tryCatch(f, (reason) => DataAccessError.of(String(reason)))

export interface HasSelect {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  select: any
}
